// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__17NrL","image":"Header_image__2GPFo","name":"Header_name__1qXMY","info":"Header_info__2VE4L","infoRow":"Header_infoRow__3tQ8y"};